// See the Design in Repo as KfW.de-Frontend/  'http://localhost:3001/components/links'

import React from 'react';
import { ILinkProps } from '../../../interfaces/interfaces';

function Link(props: ILinkProps): JSX.Element {
  const {
    linkHref,
    linkText,
    ariaLabel,
    linkClass,
    linkTarget,
    linkIconClass,
    onClick,
    onKeyDown,
    tabIndex,
    dataAttributes,
    locked,
  } = props;

  const reducedDataAttributes = dataAttributes?.reduce((obj, item) => ({ ...obj, [item.key]: item.value }), {});

  return (
    <a
      target={linkTarget}
      // eslint-disable-next-line no-script-url
      href={linkHref}
      aria-label={ariaLabel}
      className={linkClass}
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex || 0}
      role={onClick && 'button'}
      rel="noreferrer"
      /* eslint-disable react/jsx-props-no-spreading */
      {...reducedDataAttributes}
    >
      <span className={linkIconClass} aria-hidden="true" />
      <span className="link-text">{linkText}</span>
      {locked && <span className="ic-lock" />}
    </a>
  );
}
export default Link;
